import { motion } from "framer-motion";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import promoArtwork from "../assets/images/Bildup_Ad.png";
import { trackEvent } from "../utils/analytics";
import "./Promo.css";

const WHATSAPP_URL =
  "https://wa.me/2348155196615?text=Hello%20BildUp%2C%20I%27m%20interested%20in%20the%20%E2%82%A630%2C000%20brand%20growth%20package.";

const Promo = () => {
  return (
    <section id="promo" className="promo" aria-labelledby="promo-title">
      <div className="promo__glow promo__glow--left" aria-hidden="true" />
      <div className="promo__glow promo__glow--right" aria-hidden="true" />

      <div className="promo__container">
        <motion.div
          className="promo__artwork-wrap"
          initial={{ opacity: 0, x: -45 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
          viewport={{ once: true, amount: 0.25 }}
        >
          <div className="promo__artwork-frame">
            <img
              src={promoArtwork}
              alt="BildUp invitation to build a brand that connects and drives revenue"
              className="promo__artwork"
            />
          </div>
          <span className="promo__image-label">Build better. Sell smarter.</span>
        </motion.div>

        <motion.div
          className="promo__content"
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.75,
            delay: 0.1,
            ease: [0.22, 1, 0.36, 1],
          }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <p className="promo__eyebrow">BILDUP BRAND GROWTH PROMO</p>
          <h2 id="promo-title" className="promo__title">
            Posting daily but making <span>no money?</span>
          </h2>

          <p className="promo__lead">
            Or burning ad budget with zero sales?
          </p>

          <p className="promo__statement">Let&rsquo;s fix it for your brand.</p>

          <p className="promo__description">
            Get a clear bio, organized highlights, a high-converting content
            plan, and a tailored growth strategy for
          </p>

          <div className="promo__price" aria-label="30,000 naira">
            <span className="promo__price-currency">₦</span>
            <strong>30,000</strong>
          </div>

          <motion.a
            href={WHATSAPP_URL}
            onClick={() => trackEvent("whatsapp_click_promo")}
            target="_blank"
            rel="noopener noreferrer"
            className="promo__cta"
            aria-label="Chat with BildUp on WhatsApp about the 30,000 naira promo"
            whileHover={{ y: -3, scale: 1.015 }}
            whileTap={{ scale: 0.98 }}
          >
            <span className="promo__cta-icon">
              <MessageCircle size={23} fill="currentColor" aria-hidden="true" />
            </span>
            <span>Get started on WhatsApp</span>
            <ArrowUpRight size={21} aria-hidden="true" />
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default Promo;
